import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { verifyMagicLink } from '../../services/auth';

export default function MagicLinkCallback() {
  const navigate = useNavigate();
  const { loginSuccess } = useAuth();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Invalid magic link. No token found.');
      return;
    }

    verifyMagicLink(token)
      .then((result) => {
        loginSuccess(result.user, result.organization, result.tokens);
        void navigate('/');
      })
      .catch((err) => {
        setError(err.response?.data?.error || 'This link is invalid or has expired.');
      });
  }, [searchParams, loginSuccess, navigate]);

  if (error) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="login-header">
            <h1 className="login-title">Link Expired</h1>
            <p className="login-subtitle">{error}</p>
          </div>
          <button className="btn btn-primary login-btn" onClick={() => navigate('/login')}>
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1 className="login-title">Signing you in...</h1>
          <p className="login-subtitle">Please wait while we verify your login link.</p>
        </div>
      </div>
    </div>
  );
}
